import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { SortableHeader, SortableContent, SortIcon } from './SortableColumnHeader.styles';
import { SortField, SortOrder } from '../../../CustomFieldsResponses/types';

interface SortableColumnHeaderProps {
	label: string;
	sortKey: SortField;
	currentSortBy: SortField | null;
	currentOrder: SortOrder;
	onSort: (field: SortField) => void;
	align?: 'left' | 'center' | 'right';
	variant?: 'default' | 'punchup';
}

export const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({
	label,
	sortKey,
	currentSortBy,
	currentOrder,
	onSort,
	align = 'left',
	variant = 'default',
}) => {
	const isActive = currentSortBy === sortKey;

	const getSortIcon = () => {
		if (!isActive) {
			return <ArrowUpDown />;
		}
		return currentOrder === 'asc' ? <ArrowUp /> : <ArrowDown />;
	};

	return (
		<SortableHeader $align={align} $variant={variant} onClick={() => onSort(sortKey)} title={`Sort by ${label}`}>
			<SortableContent>
				{label}
				<SortIcon $isActive={isActive} $variant={variant}>
					{getSortIcon()}
				</SortIcon>
			</SortableContent>
		</SortableHeader>
	);
};
